export default {
    "account.available.Amount": "موجودی حساب کوکوین برای این کوین کافی نیست",
    //login Error
    "incorrect email/mobile  or password": "ایمیل/موبایل یا رمز عبور نادرست است",
    "incorrect email or password": "ایمیل یا رمز عبور نادرست است",
    "Email is not verified": "ایمیل شما تایید نشده است",
    "email must be a valid email": "ایمیل نادرست است",
    "user is block": "حساب کاربری شما مسدود است. لطفا با پشتیبانی تماس بگیرید",
    "No User was found": "ایمیل اشتباه است",
    "No Referred User was found": "کد معرف اشتباه است",
    //register Error
    'email is registered': 'قبلا با این ایمیل  ثبت نام انجام شده است',
    'mobile is already registered': 'قبلا با این شماره موبایل ثبت نام انجام شده است',
    '\"email\" must be a valid email': 'ایمیل نادرست است',
    'Invalid input data. Password must contain at least one letter and one number':
        "رمز عبور شما باید شامل حروف و رقم باشد",
    "mobile is registered": 'قبلا با این شماره همراه  ثبت نام انجام شده است',
    "user not found": 'شماره موبایل نادرست است',

    //identity
    'mobile or nationalCode is dublicate': "شماره موبایل یا کد ملی قبلا در سیستم ثبت شده است",
    'unvalid otp':
        'کد اشتباه است',
    'this opt is expired':
        'کد پیامکی منقضی شده است',
    'already there is an opt':
        'محدودیت زمانی برای ارسال پیامک',
    'already there is an otp':
        'محدودیت زمانی برای ارسال پیامک',

    //trade
    'user level does NOT match:identityVerified':
        'اطلاعات هویتی شما می بایست تایید شده باشد',
    'user level does NOT match:idImgVerified':
        'اطلاعات هویتی و تصویر  شما می بایست تایید شده باشد',
    'not enough credit':
        'موجودی کافی نمی باشد',
    'not enough credit.':
        'موجودی کافی نمی باشد',
    'the amount is more or less than permitted price': "مقدار در محدوده ی مجاز قیمتی نمی باشد",
    'Balance insufficient!':
        'لطفا به پشتیبانی اطلاع دهید',
    'Validation Error.': 'لطفا به پشتیبانی اطلاع دهید',
    '"q" must be one of [bitcoin, dogecoin, litecoin]': 'واریز برای کوین مورد نظر فعال نمی باشد',
    'card is NOT validate': 'کارت بانکی توسط ادمین تایید نشده است',
    'Validation Error': 'لطفا به پشتیبانی اطلاع دهید',
    'some inputs need to be unique': 'شماره شبا یا شماره کارت قبلا ثبت شده است',
    'iban is NOT valid': 'شماره شبا معتبر نمی باشد',
    'order_not_exist_or_not_allow_to_cancel': 'امکان لغو سفارش وجود ندارد',
    'dublicate txId': 'آیدی تراکنش تکراری می باشد',

    //event
    'One active event already exist': 'درحال حاضر ایونت فعال وجود دارد',
    'Cant update event status': 'تغییر مجاز نیست',
    'Event not found or not active': 'برای افزودن معامله ایونت باید در وضعیت خرید و فروش قرار بگیرد',
    //ipg
    'paymentProvider Error.': 'اختلال درگاه پرداخت',
    'permission denied': 'همکار گرامی ، به شما دسترسی این بخش داده نشده است',
    'Incorrect withdrawal address': 'آدرس مقصد اشتباه می باشد',
    'cant cancel this order': 'امکان لغو سفارش وجود ندارد',
}

